import {
  Design,
  WorkflowObject,
  WorkflowObjectLanguage
} from '../../../types';
import { getWfsFillerPrompts } from './get-wfs-filler-prompts';
import { getWfsPrompts } from './get-wfs-prompts';

export function getWfsObject(serialized: Design): WorkflowObject {
  const {
    applicationVersion,
    clientName,
    designName,
    languages
  } = serialized;

  return {
    activateSolid: true,
    application: `${clientName}${designName}`,
    client: clientName,
    languages: languages.map((language): WorkflowObjectLanguage => {
      return {
        ...language,
        generateStaticTts: !language.voice,
        readyForActivation: true
      };
    }),
    prompts: [
      ...getWfsPrompts(serialized),
      ...getWfsFillerPrompts(serialized)
    ],
    version: applicationVersion
  };
}
